module.exports = __webpack_public_path__ + "static/media/thank-you-header-img.0d4d52bc.jpg";